// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hk-0";
export var actionModalContentContainer = "_hk-1";
export var createTagButton = "_hk-2";
export var footerContainer = "_hk-7";
export var fullWidthDivider = "_hk-3";
export var hasCreateTagButton = "_hk-4";
export var noCreateTagButton = "_hk-5";
export var tagsContainer = "_hk-6";
export var tagsModalContentContainer = "_hk-8";